import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

export interface GetStatusByEntityProps {
  Id: number | number[];
}

export interface EntityStatusOption {
  nombre: string;
  ids: number[];
}
let entityStatusApiPromise: Promise<AxiosInstance> | null = null;

const getEntityStatusApi = () => {
  if (entityStatusApiPromise) return entityStatusApiPromise;
  entityStatusApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return entityStatusApiPromise;
};

export const getStatusByEntity = async (
  props: GetStatusByEntityProps,
): Promise<EntityStatusOption[] | null> => {
  const api = await getEntityStatusApi();
  if (!api) return null;
  const response = await api.get(
    `/Soporte/GetEstadosByIdEntidad?${objectToQueryStringWithArray(props)}`,
  );

  return response.data


};

export const getExternalTransferStatus = async (props?: { programadas?: boolean }): Promise<
  EntityStatusOption[] | null
> => {
  const api = await getEntityStatusApi();
  if (!api) return null;
  const queryString = objectToQueryStringWithArray(props ?? {});

  const response = await api.get(`/Soporte/EstadosTransferenciaExterna?${queryString}`);

  return response.data;
};
